/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Compare_UsersInputs */



/**
* | output |
* | --- |
* | "Number of Users***" |
*
* @param {Signup_Compare_UsersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_compare_users = /** @type {((inputs?: Signup_Compare_UsersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Compare_UsersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Number of Users***")
	if (locale === "de") return /** @type {LocalizedString} */ ("Number of Users***")
	if (locale === "it") return /** @type {LocalizedString} */ ("Number of Users***")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Number of Users***")
	if (locale === "es") return /** @type {LocalizedString} */ ("Number of Users***")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Number of Users***")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Number of Users***")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Number of Users***")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Number of Users***")
	return /** @type {LocalizedString} */ ("Number of Users***")
});